export default {
    title: 'Statistics',
    filter: {
        toggle: 'Filters',
        events: 'Events',
        eventsPlaceholder: 'All',
        devices: 'Devices',
        devicesPlaceholder: 'All',
        dateFrom: 'From',
        dateTo: 'To',
        interval: 'Resolution',
        intervalOptions: {
            auto: 'Automatic',
            day: 'Day',
            hour: 'Hour',
            minute: 'Minute'
        },
        showEmpty: 'Show empty sets',
        submit: 'Show'
    },
    prompt: {
        beforeFirstFetch: 'Set filters and click Show',
        noResults: 'No records for the selected filters'
    },
    kpi: {
        validated: 'Validated',
        total: 'Total tickets',
        percentLabel: 'of total'
    },
    table: {
        title: 'Ticket sets',
        cols: {
            id: 'ID',
            event: 'Event',
            name: 'Set',
            toCheck: 'To check',
            tickets: 'Tickets',
            people: 'People'
        },
        total: 'Total',
        sub: {
            title: 'Per-device breakdown',
            empty: 'No breakdown available',
            cols: {
                type: 'Type',
                name: 'Name',
                count: 'Count'
            }
        }
    },
    charts: {
        title: 'Device activity',
        empty: 'No activity data'
    },
    toast: {
        error: 'Error loading statistics'
    }
}
